import * as Sentry from '@sentry/browser';
import { type BrowserOptions } from '@sentry/browser';

export const init = ({
  dsn = undefined,
  integrations = [new Sentry.BrowserTracing()],
  tracesSampleRate = 1.0,
  maxBreadcrumbs = 50,
  ...otherOptions
}: BrowserOptions = {}) =>
  Sentry.init({
    dsn,

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.

    // TODO: add release by date;
    //   release: 'my-project-name@2.3.12',

    integrations,
    maxBreadcrumbs,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate,

    ...otherOptions
  });
